import * as React from 'react';
import { PageGuideDefinition } from '../../designSystem/PageGuide';
import { P } from '../../designSystem/typography/Body';

const workgroupMeetingGuide:PageGuideDefinition = {
    title:'Møder',
    content:(
		<>
        <P> På denne side kan du oprette og planlægge møder samt samle de vigtigste oplysninger ét sted. </P> 
		<P> Du kan angive <strong>tid og sted</strong> for mødet og tilføje de personer, der skal deltage. Deltagerne kan fordeles på følgende roller: </P> <ul> <li>Mødeleder</li> <li>Referent</li> <li>Øvrige deltagere</li> </ul> <P> Derudover kan du tilføje en <strong>mødebeskrivelse</strong> med relevante oplysninger om mødet samt oprette <strong>agendapunkter</strong>, så mødets emner og indhold er tydeligt struktureret. </P>
		</>
    )
};

export const pageGuides = {
    workgroupMeeting:workgroupMeetingGuide
};